/**
 * Track referral source from URL parameters or referer header
 * @returns {Object} referral information including source, medium, and campaign
 */
export const trackReferral = () => {
  const referralData = {
    source: null,
    medium: null,
    campaign: null,
    referrer: null,
  };

  // Get URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  
  // Check for UTM parameters (most reliable)
  referralData.source = urlParams.get('utm_source');
  referralData.medium = urlParams.get('utm_medium');
  referralData.campaign = urlParams.get('utm_campaign');

  // Get the referer header
  const referrer = document.referrer;
  referralData.referrer = referrer;

  // If no UTM parameters, try to parse the referer
  if (!referralData.source && referrer) {
    if (referrer.includes('tiktok.com')) {
      referralData.source = 'tiktok';
      referralData.medium = 'social';
    } else if (referrer.includes('facebook.com') || referrer.includes('fb.com')) {
      referralData.source = 'facebook';
      referralData.medium = 'social';
    } else if (referrer.includes('instagram.com')) {
      referralData.source = 'instagram';
      referralData.medium = 'social';
    } else if (referrer.includes('twitter.com') || referrer.includes('t.co')) {
      referralData.source = 'twitter';
      referralData.medium = 'social';
    } else if (referrer.includes('linkedin.com')) {
      referralData.source = 'linkedin';
      referralData.medium = 'social';
    } else if (referrer.includes('youtube.com')) {
      referralData.source = 'youtube';
      referralData.medium = 'social';
    } else if (referrer.includes('google.com')) {
      referralData.source = 'google';
      referralData.medium = 'search';
    } else {
      // Extract domain from referrer
      try {
        const refUrl = new URL(referrer);
        referralData.source = refUrl.hostname.replace('www.', '');
        referralData.medium = 'referral';
      } catch (e) {
        console.error('Error parsing referrer:', e);
      }
    }
  }

  return referralData;
};

/**
 * Save referral data to localStorage
 * @param {Object} referralData 
 */
export const saveReferralData = (referralData) => {
  try {
    localStorage.setItem('referralData', JSON.stringify({
      ...referralData,
      timestamp: new Date().toISOString(),
    }));
  } catch (e) {
    console.error('Error saving referral data:', e);
  }
};

/**
 * Get saved referral data from localStorage
 * @returns {Object|null}
 */
export const getSavedReferralData = () => {
  try {
    const data = localStorage.getItem('referralData');
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error('Error getting referral data:', e);
    return null;
  }
};
